import { makeStyles } from '@mui/styles';

const useRequestsTable = makeStyles({
	th: {
		height: 50,
		fontWeight: 600,
		fontSize: '16px',
		color: '#1063AC',
		background: '#E2EBF3',
		fontFamily: 'Montserrat',
	},
	table: {
		width: '97%',
		marginLeft: 20,
		borderSpacing: '0 5px',
		borderCollapse: 'separate',
	},
	thead: {
		'& th:first-child': {
			borderRadius: '10px 0 0 10px',
		},
		'& th:last-child': {
			borderRadius: '0 10px 10px 0',
		},
	},
	tr: {
		boxShadow: '0px 1px 3px #00000029',
		borderRadius: '57px',
		'& td:first-child': {
			borderRadius: '100px 0 0 100px',
		},
		'& td:last-child': {
			borderRadius: '0 100px 100px 0',
		},
	},
	td: {
		opacity: 1,
		height: 50,
		fontWeight: 100,
		fontSize: '16px',
		color: '#686868c4',
		background: 'white',
	},

	tooltipBottom: {
		backgroundColor: '#00ADEE !important',
		fontFamily: 'Montserrat !important',
		fontWeight: '400 !important',
		fontSize: '12px !important',
		width: 80,
		maxWidth: '90px !important',
		borderRadius: '15px !important',
		padding: '7px 0px !important',
		textAlign: 'center',
		boxShadow: '0px 3px 5px #00000029',
	},
	arrow: {
		marginLeft: '-0.6em !important',
		'&:before': {
			backgroundColor: '#00ADEE !important',
		},
	},
	arrowBottom: {
		'&:before': {
			backgroundColor: '#00ADEE !important',
		},
	},
	tablePadre: {
		overflow: 'auto',
		padding: '3px',
		paddingRight: '8px !important',
		paddingTop: '0px !important',
		'&::-webkit-scrollbar': {
			width: 5,
			height: 5,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#E9E9E9',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#ABABAB',
			borderRadius: 7,
		},
	},
	button: {
		color: '#1063AC !important',
		fontWeight: 'bold !important',
	},

	tooltipBottomCampo: {
		backgroundColor: '#00ADEE !important',
		fontFamily: 'Montserrat !important',
		fontWeight: '400 !important',
		fontSize: '12px !important',
		borderRadius: '15px !important',
		padding: '8px 10px !important',
		maxWidth: '600px !important',
		textAlign: 'center',
		boxShadow: '0px 3px 5px #00000029',
	},

	noResultMesagge: {
		overflow: 'auto',
		height: '60vh',
		paddingBottom: 40,
		'&::-webkit-scrollbar': {
			width: 0,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#E9E9E9',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#ABABAB',
			borderRadius: 7,
		},
	},
});

export default useRequestsTable;
